import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./Login.css";
import db, { auth, provider } from "../../firebase";
import Modal from "react-modal";
import { Button } from "@material-ui/core";
import { login } from "../../Features/userSlice";

function Login() {
  const history = useHistory();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const dispatch = useDispatch();

  const routeChange = () => {
    let path = "/";
    history.push(path);
  };

  const googleSignIn = () => {
    auth
      .signInWithPopup(provider)
      .then(() => {
        createUserDataFromGoogle();
        routeChange();
        dispatch(
          login({
            displayName: auth.currentUser.displayName,
            email: auth.currentUser.email,
            photo: auth.currentUser.photoURL,
            uid: auth.currentUser.uid,
          })
        );
      })
      .catch((e) => {
        // alert(e.message);
      });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth.user.emailVerified) {
          window.alert("You signed in!");
          db.collection("users")
            .doc(auth.user.uid)
            .get()
            .then((doc) => {
              dispatch(
                login({
                  displayName: doc.data().displayName,
                  email: doc.data().email,
                  uid: doc.data().uid,
                })
              );
            });

          routeChange();
        }
      })
      .catch((e) => alert(e.message));

    setEmail("");
    setPassword("");
  };

  const handleRegister = (e) => {
    e.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth) {
          window.alert("Check your email for a link");
          handleVerification();
        }
      })
      .catch((e) => alert(e.message));

    setDisplayName("");
    setEmail("");
    setPassword("");
  };

  const handleVerification = () => {
    let user = auth.currentUser;

    user
      .sendEmailVerification()
      .then(function () {
        // Email sent.
        createUserDataFromForm();
        setOpenModal(false);
      })
      .catch(function (error) {
        // An error happened.
      });
  };

  const createUserDataFromForm = () => {
    db.collection("users").doc(auth.currentUser.uid).set({
      displayName: displayName,
      email: email,
      photo: auth.currentUser.photoURL,
      uid: auth.currentUser.uid,
    });
  };

  const createUserDataFromGoogle = () => {
    db.collection("users").doc(auth.currentUser.uid).set({
      displayName: auth.currentUser.displayName,
      email: auth.currentUser.email,
      photo: auth.currentUser.photoURL,
      uid: auth.currentUser.uid,
    });
  };

  return (
    <div className="login">
      <div className="login__container">
        <div className="login__logo">BuildFaast</div>
        <div className="login__desc">
          <p>
            Figure out how to build software apps while you're learning with a
            community
          </p>
          <p style={{ color: "royalblue", fontSize: "25px" }}>
            HandCrafted with ❤️ by{" some good folks of the internet"}
          </p>
        </div>
        <div className="login__auth">
          <div className="login__authOptions">
            <div className="login__authOption">
              <img
                className="login__googleAuth"
                src="https://media-public.canva.com/MADnBiAubGA/3/screen.svg"
                alt=""
              />
              <p onClick={googleSignIn}>Continue With Google</p>
            </div>
            {/* <div className="login__authOption">
							<img
								className="login__googleAuth"
								src="https://1000logos.net/wp-content/uploads/2016/11/Facebook-logo-500x350.png"
								alt=""
							/>
							<span>Continue With Facebook</span>
						</div> */}
            {/* <div className="login__authDesc">
							<p>
								<span style={{ color: "blue", cursor: "pointer" }}>
									Sign Up With Email
								</span>
								.
							</p>
						</div> */}
          </div>
          <div className="login__emailPass">
            <div className="login__label">
              <h4>Login</h4>
            </div>
            <div className="login__inputFields">
              <div className="login__inputField">
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                  placeholder="Email"
                />
              </div>
              <div className="login__inputField">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Password"
                />
              </div>
            </div>
            <Button onClick={handleLogin}>Login</Button>
            <Button onClick={() => setOpenModal(true)}>Register</Button>
            {/* <div className="login__forgButt">
							<small>Forgot Password?</small>
						</div> */}
            <Modal
              isOpen={openModal}
              onRequestClose={() => setOpenModal(false)}
              shouldCloseOnOverlayClick={true}
              style={{
                overlay: {
                  width: 700,
                  height: 650,
                  backgroundColor: "transparent",
                  boxShadow:
                    "box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                  zIndex: "1000",
                  top: "50%",
                  left: "50%",
                  marginTop: "-350px",
                  marginLeft: "-380px",
                },
              }}
            >
              <div className="register__emailPass">
                <div className="register__label">
                  <h4>Register here</h4>
                </div>
                <div className="register__inputFields">
                  <div className="register__inputField">
                    <input
                      value={displayName}
                      onChange={(e) => setDisplayName(e.target.value)}
                      type="text"
                      placeholder="User Name"
                    />
                  </div>
                  <div className="register__inputField">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="text"
                      placeholder="Email"
                    />
                  </div>
                  <div className="register__inputField">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type="password"
                      placeholder="Password"
                    />
                  </div>
                </div>
                <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                <Button onClick={handleRegister}>Register</Button>
              </div>
            </Modal>
          </div>
        </div>

        <div className="login__footer">
          <p>&copy; BuildFaast 2021</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
